'use strict';

/* globals window, $, config, ajaxify */

$(window).on('action:ajaxify.end', function (event, data) {
	if (data.tpl_url === 'groups/details') {
		$('#care-calculator-join-btn').click(function () {
			window.location.href = config.relative_path + '/groups/' + ajaxify.data.group.slug + '/care-calculator';
		});
	}
});
